import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-spinner',
    imports: [CommonModule, FontAwesomeModule],
    templateUrl: './spinner.component.html',
    styleUrl: './spinner.component.css'
})
export class SpinnerComponent {
  @Input() size: 'small' | 'normal' = 'normal';
  constructor(library: FaIconLibrary) {
    library.addIcons(faSpinner);
  }
}